import { Component, Input } from '@angular/core'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatMenuModule } from '@angular/material/menu'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmLeaveGameDialogComponent } from '../leave-game-dialog/confirm-leave-game-dialog.component'
import { NgIf } from '@angular/common'

@Component({
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    NgIf,
  ],
  selector: 'sans-leave-game-play',
  templateUrl: './leave-game-play.component.html',
  styleUrls: ['./leave-game-play.component.scss'],
})
export class LeaveGamePlayComponent {
  @Input() public gamePlayId = ''
  @Input() public isHamburgerMenuItem = false
  public leaveGameButtonLabel = $localize`:Button label|Dashboard leave game button label:Leave Game`

  public constructor(private readonly dialog: MatDialog) {}

  public async onLeaveGame(): Promise<void> {
    this.dialog.open(ConfirmLeaveGameDialogComponent, {
      data: this.gamePlayId,
    })
  }
}
